import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import getIntl from 'Helpers/intl'

import {
  OPTOUT_TYPE_OBLIO,
  OPTOUT_TYPE_PLATFORM,
  beRecipientUnsubscribeByCustomSearchParams,
  beRecipientUnsubscribeBySelectionParams,
} from 'Api/beRecipientApi'

import type { SearchFiltersState } from 'Pages/RecipientsList/model'

import {
  searchFiltersToConditions,
  toSubscriptionStatus,
} from 'Pages/RecipientsList/recoil/services/results'

export const bulkUnsubscribe = async (
  {
    mode,
    checked,
    searchFilters,
  }: {
    mode: 'all' | 'selection'
    checked: number[]
    searchFilters: SearchFiltersState
  },
  {
    channelEmail,
    channelSMS,
    wipeData,
  }: {
    channelEmail: boolean
    channelSMS: boolean
    wipeData: boolean
  },
): Promise<void> => {
  if (mode === 'selection' && checked.length === 0) {
    return
  }

  const idList = storeGet(STORE_KEY_ID_LIST)
  const optoutType = wipeData ? OPTOUT_TYPE_OBLIO : OPTOUT_TYPE_PLATFORM

  const channel =
    channelEmail && channelSMS ? 'All' : channelEmail ? 'Email' : 'Sms'

  if (mode === 'selection' && checked.length > 0) {
    await beRecipientUnsubscribeBySelectionParams(
      idList,
      channel,
      checked,
      optoutType,
      'CONSOLE',
    )
  } else {
    const reqIn = {
      Conditions: searchFiltersToConditions(searchFilters),
      SubscriptionStatus: toSubscriptionStatus(searchFilters.status.value),
      Channel: channel,
      OptOutType: optoutType,
    }

    await beRecipientUnsubscribeByCustomSearchParams(idList, reqIn, 'CONSOLE')
  }
}

export const notifyBulkUnsubscription = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.BulkUnsubscribeSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}
